import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのOperationCalendarロゴアイコン
 */
export function ProductLogoSmallOperationCalendar({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1035 4.75H4.10352L4.10352 16.75H16.1035V4.75ZM4.10352 3.25C3.27509 3.25 2.60352 3.92157 2.60352 4.75V16.75C2.60352 17.5784 3.27509 18.25 4.10352 18.25H16.1035C16.9319 18.25 17.6035 17.5784 17.6035 16.75V4.75C17.6035 3.92157 16.9319 3.25 16.1035 3.25H4.10352Z"
        fill={color}
      />
      <path
        d="M7.60352 2.25C7.60352 1.97386 7.37966 1.75 7.10352 1.75H6.60352C6.32737 1.75 6.10352 1.97386 6.10352 2.25V4.25C6.10352 4.52614 6.32737 4.75 6.60352 4.75H7.10352C7.37966 4.75 7.60352 4.52614 7.60352 4.25V2.25Z"
        fill={color}
      />
      <path
        d="M14.1035 2.25C14.1035 1.97386 13.8797 1.75 13.6035 1.75H13.1035C12.8274 1.75 12.6035 1.97386 12.6035 2.25V4.25C12.6035 4.52614 12.8274 4.75 13.1035 4.75H13.6035C13.8797 4.75 14.1035 4.52614 14.1035 4.25V2.25Z"
        fill={color}
      />
      <path
        d="M16.6035 4.25C16.8797 4.25 17.1035 4.47386 17.1035 4.75V7.75C17.1035 8.02614 16.8797 8.25 16.6035 8.25L3.60352 8.25C3.32737 8.25 3.10352 8.02614 3.10352 7.75L3.10352 4.75C3.10352 4.47386 3.32737 4.25 3.60352 4.25L16.6035 4.25Z"
        fill={color}
      />
      <path
        d="M7.10352 9.75C7.37966 9.75 7.60352 9.97386 7.60352 10.25V11.25C7.60352 11.5261 7.37966 11.75 7.10352 11.75H6.10352C5.82737 11.75 5.60352 11.5261 5.60352 11.25V10.25C5.60352 9.97386 5.82737 9.75 6.10352 9.75H7.10352Z"
        fill={color}
      />
      <path
        d="M10.6035 9.75C10.8797 9.75 11.1035 9.97386 11.1035 10.25V11.25C11.1035 11.5261 10.8797 11.75 10.6035 11.75H9.60352C9.32737 11.75 9.10352 11.5261 9.10352 11.25V10.25C9.10352 9.97386 9.32737 9.75 9.60352 9.75H10.6035Z"
        fill={color}
      />
      <path
        d="M14.1035 9.75C14.3797 9.75 14.6035 9.97386 14.6035 10.25V11.25C14.6035 11.5261 14.3797 11.75 14.1035 11.75H13.1035C12.8274 11.75 12.6035 11.5261 12.6035 11.25V10.25C12.6035 9.97386 12.8274 9.75 13.1035 9.75H14.1035Z"
        fill={color}
      />
      <path
        d="M14.1035 13.25C14.3797 13.25 14.6035 13.4739 14.6035 13.75V14.75C14.6035 15.0261 14.3797 15.25 14.1035 15.25H13.1035C12.8274 15.25 12.6035 15.0261 12.6035 14.75V13.75C12.6035 13.4739 12.8274 13.25 13.1035 13.25H14.1035Z"
        fill={color}
      />
      <path
        d="M7.10352 13.25C7.37966 13.25 7.60352 13.4739 7.60352 13.75V14.75C7.60352 15.0261 7.37966 15.25 7.10352 15.25H6.10352C5.82737 15.25 5.60352 15.0261 5.60352 14.75V13.75C5.60352 13.4739 5.82737 13.25 6.10352 13.25H7.10352Z"
        fill={color}
      />
      <path
        d="M10.6035 13.25C10.8797 13.25 11.1035 13.4739 11.1035 13.75V14.75C11.1035 15.0261 10.8797 15.25 10.6035 15.25H9.60352C9.32737 15.25 9.10352 15.0261 9.10352 14.75V13.75C9.10352 13.4739 9.32737 13.25 9.60352 13.25H10.6035Z"
        fill={color}
      />
    </svg>
  );
}
